import pb from '../lib/pocketbase';

export async function getPrecios(page, perPage) {
  return await pb.collection('precio').getList(page, perPage, {
    sort: '-created', // Ordenar por fecha de creación descendente
    $autoCancel: false,
    expand: '' // Ajusta si necesitas expandir relaciones
  });
}

export async function createPrecio(precio) {
  return await pb.collection('precio').create(precio);
}

export async function updatePrecio(id, precio) {
  return await pb.collection('precio').update(id, precio);
}

export async function deletePrecio(id) {
  return await pb.collection('precio').delete(id);
}
